var React = require('react');

function Minimize (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M4 18v2h6.586L2 28.582 3.414 30 12 21.414V28h2V18H4ZM30 3.416 28.592 2 20 10.586V4h-2v10h10v-2h-6.586L30 3.416ZM14 4h-2v6.586L3.418 2 2 3.414 10.586 12H4v2h10V4ZM28.584 30 30 28.592 21.414 20H28v-2H18v10h2v-6.586L28.584 30Z","style":{"fillRule":"nonzero"}}));
}

Minimize.defaultProps = {"xmlSpace":"preserve","style":{"fillRule":"evenodd","clipRule":"evenodd","strokeLinejoin":"round","strokeMiterlimit":"2"},"viewBox":"0 0 32 32"};

module.exports = Minimize;

Minimize.default = Minimize;
